import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoriesGetRequest = simpleAction(TYPES.CATEGORIES_GET_REQUEST);

/**
 * Request categories success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoriesGetSuccess = simpleAction(TYPES.CATEGORIES_GET_SUCCESS);

/**
 * Request categories error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoriesGetError = simpleAction(TYPES.CATEGORIES_GET_FAIL);

/**
 * Request Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryLoadRequest = simpleAction(TYPES.CATEGORY_LOAD_REQUEST);

/**
 * Request Order success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryLoadSuccess = simpleAction(TYPES.CATEGORY_LOAD_SUCCESS);

/**
 * Request Order error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryLoadError = simpleAction(TYPES.CATEGORY_LOAD_FAIL);

/**
 * Create Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryCreateRequest = simpleAction(TYPES.CATEGORY_CREATE_REQUEST);

/**
 * Create Order Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryCreateSuccess = simpleAction(TYPES.CATEGORY_CREATE_SUCCESS);

/**
 * Create Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryCreateError = simpleAction(TYPES.CATEGORY_CREATE_FAIL);

/**
 * Create Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryCreateDone = simpleAction(TYPES.CATEGORY_CREATE_DONE);

/**
 * Update Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryUpdateRequest = simpleAction(TYPES.CATEGORY_UPDATE_REQUEST);

/**
 * Update Order Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryUpdateSuccess = simpleAction(TYPES.CATEGORY_UPDATE_SUCCESS);

/**
 * Update Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryUpdateError = simpleAction(TYPES.CATEGORY_UPDATE_FAIL);

/**
 * Update Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const categoryUpdateDone = simpleAction(TYPES.CATEGORY_UPDATE_DONE);
